export default "__VITE_ASSET__CSOP0CWY__"